// ---------------------------------------------------------------------------
// Text Block Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text } from "../escape.js";

interface TextBlockProps {
  heading?: string;
  content: string;
  alignment?: "left" | "center" | "right";
  maxWidth?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as TextBlockProps;

  const content = p.content ?? "";
  const alignment = p.alignment ?? "left";
  const maxWidth = p.maxWidth ?? "720px";

  const headingHtml = p.heading
    ? `\n    <h2 class="ease-text-heading">${text(p.heading)}</h2>`
    : "";

  const paragraphs = content
    .split(/\n\n+/)
    .filter((para) => para.trim().length > 0)
    .map((para) => `    <p>${text(para.trim())}</p>`)
    .join("\n");

  return `<section class="ease-section ease-text-block" aria-label="${attr(p.heading ?? "Content")}">
  <div class="ease-text-content" style="text-align: ${attr(alignment)}; max-width: ${attr(maxWidth)}; margin: 0 auto;">${headingHtml}
${paragraphs}
  </div>
</section>`;
}

registerRenderer("text-block", { render });
